"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalHoldingsUsd = getTotalHoldingsUsd;
exports.getAlphaHeld = getAlphaHeld;
exports.getHoldingsDistribution = getHoldingsDistribution;
const decimal_js_1 = require("decimal.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
async function getTotalHoldingsUsd(params) {
    let response = "";
    const totalHoldings = params.treasuryHoldings.total.totalUsdBalance;
    if (!totalHoldings)
        throw new Error("Total Holding not found");
    response = totalHoldings;
    return response;
}
async function getAlphaHeld(params) {
    let response = "";
    let alphaHeld = new decimal_js_1.Decimal(0);
    const { treasuryHoldings } = params;
    const poolWithAlpha = Object.keys(alphafi_sdk_1.poolInfo)
        .filter((poolName) => poolName.split("-").includes("ALPHA"))
        .map((poolName) => poolName);
    poolWithAlpha.forEach((poolName) => {
        const holding = treasuryHoldings.alphafi[poolName];
        if (holding) {
            if ("tokens" in holding) {
                alphaHeld = alphaHeld.add(new decimal_js_1.Decimal(holding.tokens));
            }
            else if ("tokensA" in holding) {
                alphaHeld = alphaHeld.add(new decimal_js_1.Decimal(holding.tokensA));
            }
        }
    });
    alphaHeld = alphaHeld.add(new decimal_js_1.Decimal(treasuryHoldings.alphalend["0xfe3afec26c59e874f3c1d60b8203cb3852d2bb2aa415df9548b8d688e6683f93::alpha::ALPHA"].tokens));
    if (alphaHeld.isZero())
        return "0";
    response = alphaHeld.toFixed(3);
    return response;
}
async function getHoldingsDistribution(params) {
    const response = {};
    const { treasuryHoldings, prices } = params;
    const coinHoldingsMap = new Map();
    Object.entries(treasuryHoldings.alphafi).forEach(([pool, holding]) => {
        if ("tokens" in holding) {
            // to get sui as coin
            const coin = (0, alphafi_sdk_1.coinsInPool)(pool, {
                type: (0, alphafi_sdk_1.getConf)().NAVI_LOOP_SUI_VSUI_POOL_LIQUIDITY_CHANGE_EVENT,
                event_type: 0,
            });
            const coinAmt = coinHoldingsMap.get(coin);
            if (!coinAmt) {
                coinHoldingsMap.set(coin, new decimal_js_1.Decimal(holding.usdBalance));
            }
            else {
                coinHoldingsMap.set(coin, coinAmt.add(new decimal_js_1.Decimal(holding.usdBalance)));
            }
        }
        else if ("tokensA" in holding) {
            const { coinA, coinB } = (0, alphafi_sdk_1.coinsInPool)(pool);
            const coinAPrice = prices[coinA];
            const coinBPrice = prices[coinB];
            if (!coinAPrice)
                throw new Error(`price not found for ${coinA}`);
            if (!coinBPrice)
                throw new Error(`price not found for ${coinB}`);
            const thisCoinAHolding = new decimal_js_1.Decimal(holding.tokensA).mul(new decimal_js_1.Decimal(coinAPrice));
            const thisCoinBHolding = new decimal_js_1.Decimal(holding.tokensB).mul(new decimal_js_1.Decimal(coinBPrice));
            const coinAmtA = coinHoldingsMap.get(coinA);
            const coinAmtB = coinHoldingsMap.get(coinB);
            if (!coinAmtA) {
                coinHoldingsMap.set(coinA, thisCoinAHolding);
            }
            else {
                coinHoldingsMap.set(coinA, coinAmtA.add(thisCoinAHolding));
            }
            if (!coinAmtB) {
                coinHoldingsMap.set(coinB, thisCoinBHolding);
            }
            else {
                coinHoldingsMap.set(coinB, coinAmtB.add(thisCoinBHolding));
            }
        }
    });
    // ADD ALPHALEND HOLDINGS TO THE COIN MAP
    Object.entries(treasuryHoldings.alphalend).forEach(([marketCoinType, holding]) => {
        const coinName = Object.keys(alphafi_sdk_1.coinsList).find((coinName) => alphafi_sdk_1.coinsList[coinName].type === marketCoinType);
        if (!coinName)
            throw new Error(`Coin Name not found for ${marketCoinType}`);
        const coinPrice = prices[coinName];
        if (!coinPrice)
            throw new Error(`Price not found for ${coinName}`);
        const coinAmt = coinHoldingsMap.get(coinName);
        if (!coinAmt) {
            coinHoldingsMap.set(coinName, new decimal_js_1.Decimal(holding.tokens).mul(new decimal_js_1.Decimal(coinPrice)));
        }
        else {
            coinHoldingsMap.set(coinName, coinAmt.add(new decimal_js_1.Decimal(holding.tokens).mul(new decimal_js_1.Decimal(coinPrice))));
        }
    });
    // total holdings usd
    const totalUsdHoldings = treasuryHoldings.total.totalUsdBalance;
    // Update required if any other stable coin added
    const stables = alphafi_sdk_1.stableCoins;
    Array.from(coinHoldingsMap).map(([coin, usdAmount]) => {
        const percentHolding = usdAmount.div(totalUsdHoldings).mul(100);
        if (stables.includes(coin)) {
            if (!response["Stables"])
                response["Stables"] = percentHolding.toString();
            else {
                response["Stables"] = new decimal_js_1.Decimal(response["Stables"])
                    .add(percentHolding)
                    .toString();
            }
        }
        else if (coin === "SUI" || coin === "STSUI") {
            if (!response["Sui"])
                response["Sui"] = percentHolding.toString();
            else {
                response["Sui"] = new decimal_js_1.Decimal(response["Sui"])
                    .add(percentHolding)
                    .toString();
            }
        }
        else if (coin === "ALPHA") {
            if (!response["ALPHA"])
                response["ALPHA"] = percentHolding.toString();
            else {
                response["ALPHA"] = new decimal_js_1.Decimal(response["ALPHA"])
                    .add(percentHolding)
                    .toString();
            }
        }
        else {
            if (!response["Others"])
                response["Others"] = percentHolding.toString();
            else {
                response["Others"] = new decimal_js_1.Decimal(response["Others"])
                    .add(percentHolding)
                    .toString();
            }
        }
    });
    return response;
}
//# sourceMappingURL=treasury.js.map